// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slidecontainer .header{float:left}.slidecontainer .value{float:right}`, "",{"version":3,"sources":["webpack://./node_modules/@dragon/ui-common/lib/esm/Components/HtmlRangeInput.scss"],"names":[],"mappings":"AACE,wBACE,UAAA,CAEF,uBACE,WAAA","sourcesContent":[".slidecontainer {\r\n  .header {\r\n    float: left;\r\n  }\r\n  .value {\r\n    float: right;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
